import { Component, ElementRef, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NotificationService } from 'src/app/Service/notification.service';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { OtherService } from 'src/app/Service/other.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Validators } from '@angular/forms';
import Hls from 'hls.js';
import flvjs from 'flv.js';
import axios from 'src/app/Service/axios';
import axios_2 from 'src/app/Service/axios-dotone';
import * as moment from 'moment-jalaali'
import momentJalaali from 'moment-jalaali';
declare let $: any;



@Component({
  selector: 'video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.css']
})

export class VideoPlayerComponent implements OnInit {
  @Input() isHideInfo: boolean = false;
  @Input() src!: string;
  @Input() maxHeight: string = 'initial';
  @Input() obj_Cam!: any;
  @Input() expiresAt!: number;
  @Input() tripId!: number;
  @Input() ScreenShot!: boolean;
  @ViewChild('video') videoRef!: ElementRef<HTMLVideoElement>;

  isPlaying = false;
  bEditMode: boolean = false;
  isMuted = false;
  private hls?: Hls;
  private flvPlayer?: flvjs.Player;

  // Audio stream recording ... 
  private audioCtx!: AudioContext;
  private processor!: ScriptProcessorNode;
  private source!: MediaStreamAudioSourceNode;
  private stream!: MediaStream;
  private isRecording = false;

  mdlTempAccess: FormGroup = this.FormBuilder.group({

    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

    strUnitID: new FormControl(''),

    iTemporaryAccess: new FormControl(''),

    strSDate: new FormControl('', Validators.required),

    strSTime: new FormControl('', Validators.required),

    strEDate: new FormControl('', Validators.required),

    strETime: new FormControl('', Validators.required),

    strMobile: new FormControl('', Validators.required),

    strPassword: new FormControl('', Validators.required),

  })

  constructor(

    private tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private gurdService: GurdServiceService,

    private otherService: OtherService,

    private router: Router,

    private route: ActivatedRoute

  ) { }

  ngOnInit(): void {

    if (this.expiresAt) {

      const targetTime = this.expiresAt * 1000;

      const now = Date.now();

      const delay = targetTime - now;

      if (delay > 0) {

        setTimeout(() => {

          this.terminateStreaming();

        }, delay);

      }

      else {

        this.terminateStreaming();

      }

    }

    if (this.obj_Cam?.strUnitId && this.obj_Cam.strUnitId.includes('-')) {

      this.mdlTempAccess.controls['strUnitID'].setValue(this.obj_Cam.strUnitId.split('-')[0]);

    }

    else {

      this.mdlTempAccess.controls['strUnitID'].setValue(this.obj_Cam.strUnitID);


    }

    $('.clockpicker').clockpicker({

      donetext: 'top',

      align: 'top',

      autoclose: true,

    });

  }

  initMaxHeight() {

    const breakpoints = [

      { height: 2337, maxHeight: 'initial' },

      { height: 1458, maxHeight: 'initial' },

      { height: 1219, maxHeight: 'initial' },

      { height: 724, maxHeight: '100px' }

    ];

    const matchingBreakpoint = breakpoints.find(bp => window.innerHeight >= bp.height);

    if (matchingBreakpoint) {

      this.maxHeight = matchingBreakpoint.maxHeight;

    }

    else {

      this.maxHeight = 'initial';

    }

  }

  ngAfterViewInit(): void {

    setTimeout(() => {

      this.togglePlay();

    }, 400);

    const video = this.videoRef.nativeElement;

    video.muted = true;

    this.isMuted = true;

    if (this.src.endsWith('.m3u8')) {

      if (Hls.isSupported() && !this.isIOS()) {

        this.hls = new Hls();

        this.hls.loadSource(this.src);

        this.hls.attachMedia(video);

      }

      else {

        video.src = this.src;

        video.setAttribute('playsinline', 'true');

        video.setAttribute('webkit-playsinline', 'true');

      }

    }

    else if (this.src.endsWith('.flv')) {

      if (flvjs.isSupported()) {

        this.flvPlayer = flvjs.createPlayer({ type: 'flv', url: this.src });

        this.flvPlayer.attachMediaElement(video);

        this.flvPlayer.load();

      }

      else {

        video.src = this.src;

        video.muted = true;

        this.isMuted = true;

      }

    }

    else {

      video.src = this.src;

    }


  }

  ngOnDestroy(): void {

    if (this.hls) {
      this.hls.destroy();
    }

    if (this.flvPlayer) {
      this.flvPlayer.destroy();
    }

  }

  private isIOS(): boolean {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !('MSStream' in window);
  }

  togglePlay() {

    const video = this.videoRef.nativeElement;

    if (video.paused) {

      video.play();

      this.isPlaying = true;

    }

    else {
      video.pause();
      this.isPlaying = false;
    }

  }

  toggleMute() {

    const video = this.videoRef.nativeElement;

    video.muted = !video.muted;

    this.isMuted = video.muted;

  }

  zoom() {
    window.open(this.src, '_blank');
  }

  cancel() {

    const video = this.videoRef.nativeElement;

    video.pause();

    video.src = '';

    if (this.hls) {

      this.hls.destroy();

      this.hls = undefined;

    }

    if (this.flvPlayer) {

      this.flvPlayer.unload();

      this.flvPlayer.detachMediaElement();

      this.flvPlayer.destroy();

      this.flvPlayer = undefined;

    }

  }

  liveShare() {

    this.mdlTempAccess.patchValue({

      strSDate: momentJalaali().format('jYYYY/jMM/jDD'),

      strSTime: momentJalaali().format('HH:mm'),

      strEDate: momentJalaali().format('jYYYY/jMM/jDD'),

      strETime: '23:59',

      strMobile: '',

      strPassword: '',

    })

    // $("#tempAccess-modal").modal("show");

    $(`#${this.obj_Cam.strUnitId}-modal`).modal("show");



  }

  async new_TempAccess() {

    const Stime = document.getElementById("Stime") as any;

    const Etime = document.getElementById("Etime") as any;

    const strSTime = moment(Stime.value.trim(), 'HH:mm').format('HH:mm');

    this.mdlTempAccess.get('strSTime')?.setValue(Stime.value);

    this.mdlTempAccess.get('strETime')?.setValue(Etime.value);

    if (this.mdlTempAccess.invalid) return this.tooltip.showError('لطفا فرم را با دقت تکمیل کنید');

    if (moment(this.mdlTempAccess.get('strSDate')?.value.trim(), 'jYYYY/jMM/jDD').isBefore(moment(), 'day')) {

      return this.tooltip.showError('تاریخ شروع نمی تواند قبل از امروز باشد');

    }

    if (moment(this.mdlTempAccess.get('strEDate')?.value.trim(), 'jYYYY/jMM/jDD').isBefore(moment(), 'day')) {

      return this.tooltip.showError('تاریخ پایان نمی تواند قبل از امروز باشد');

    }

    if (moment(this.mdlTempAccess.get('strEDate')?.value.trim(), 'jYYYY/jMM/jDD').isBefore(moment(this.mdlTempAccess.get('strSDate')?.value.trim(), 'jYYYY/jMM/jDD'))) {

      return this.tooltip.showError('تاریخ پایان نمی تواند قبل از تاریخ شروع باشد');

    }

    if (moment(strSTime, 'HH:mm').isBefore(moment(moment().format('HH:mm'), 'HH:mm'))) {

      return this.tooltip.showError(`ساعت شروع نمی تواند گذشته باشد. (زمان فعلی : ${moment().format('HH:mm')})`);

    }

    if (this.mdlTempAccess.get('strMobile')?.value.length < 10) return this.tooltip.showError('لطفا شماره موبایل را به درستی وارد کنید');

    this.otherService.Showspinner();

    const resp = await axios.post(`TemporaryAccess_Save`, this.otherService.stringNumberToNumber(this.mdlTempAccess.value));

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.iResult == 0) return this.tooltip.showError(res.strError);

    this.tooltip.showSuccess('با موفقیت ثبت شد');

    $("#tempAccess-modal").modal("hide");



  }

  takeScreenshot() {

    const video = this.videoRef.nativeElement;
    const canvas = document.createElement('canvas');

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const context = canvas.getContext('2d');

    if (context) {
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      const image = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = image;
      link.download = `screenshot-${this.tripId ?? new Date()}.png`;
      link.click();

    }

  }

  async startTalk() {

    try {

      await fetch(`${(<any>window).baseUrl}StartCameraTalk`, {

        method: 'POST',

        headers: { 'Content-Type': 'application/json' },

        body: JSON.stringify({

          iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

          strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

          strUnitID: this.mdlTempAccess.get('strUnitID')?.value

        })

      });

      //  گرفتن دسترسی میکروفون

      this.stream = await navigator.mediaDevices.getUserMedia({ audio: true });

      this.audioCtx = new AudioContext({ sampleRate: 44100 }); // PCM 44.1kHz

      this.source = this.audioCtx.createMediaStreamSource(this.stream);

      // پردازش داده‌های صدا (Float32 → PCM16)

      // bufferSize=4096 → حدوداً هر 93ms در 44.1kHz

      this.processor = this.audioCtx.createScriptProcessor(4096, 1, 1);

      this.source.connect(this.processor);

      this.processor.connect(this.audioCtx.destination);

      this.isRecording = true;

      this.processor.onaudioprocess = (event) => {

        if (!this.isRecording) return;

        const input = event.inputBuffer.getChannelData(0); // تک کاناله (mono)

        const pcm16 = this.floatTo16BitPCM(input);

        this.sendChunk(pcm16);

      };

    }

    catch (err) {

      alert("start Talking error");

      console.error("❌ startTalk error:", err);

    }

  }

  async openLink() {
    this.otherService.Showspinner();
    const resp = await axios_2.post(`FleetYar_VehicleliveURL`, this.otherService.stringNumberToNumber(this.mdlTempAccess.value));
    this.otherService.nonespinner();
    let res = resp.data;
    if (res.iResult == 0) return this.tooltip.showError(res.strError);
    window.open(res.LiveURL, '_blank')
  }

  public stopTalk() {

    this.isRecording = false;

    if (this.processor) this.processor.disconnect();

    if (this.source) this.source.disconnect();

    if (this.audioCtx) this.audioCtx.close();

    if (this.stream) this.stream.getTracks().forEach(t => t.stop());

    fetch(`${(<any>window).baseUrl}StopCameraTalk`, {

      method: 'POST',

      headers: { 'Content-Type': 'application/json' },

      body: JSON.stringify({

        iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

        strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

        strUnitID: this.mdlTempAccess.get('strUnitID')?.value

      })

    });

  }

  private async terminateStreaming() {

    const video = this.videoRef.nativeElement;

    video.pause();

    this.isPlaying = false;

    const key = { strKey: this.gurdService.decrypt(localStorage.getItem('liveKey')!) }

    await axios_2.post(`CancelVideoStream`, this.otherService.stringNumberToNumber(key));

    // this.tooltip.showError('پایان مشاهده فیلم کابین!');

    $.confirm({

      title: 'پایان مشاهده فیلم کابین!',

      content: '',

      type: '',

      buttons: {

        ok: {

          text: "بستن",

          btnClass: 'btn-secondary',

          keys: ['enter'],

        },

      }

    });

  }

  private async sendChunk(pcm16: ArrayBuffer) {

    try {

      await fetch(`${(<any>window).baseUrl}Direct`, {

        method: 'POST',

        body: pcm16,

        headers: {

          'Content-Type': 'application/octet-stream',

          'iSystemUser': this.gurdService.decrypt(window.localStorage.getItem('ID')!),

          'strSession': this.gurdService.decrypt(window.localStorage.getItem('Session')!),

          'strUnitID': this.mdlTempAccess.get('strUnitID')?.value

        }

      });

    }

    catch (err) {

      alert("sendChunk error");

      console.error("❌ sendChunk error:", err);

    }

  }

  private floatTo16BitPCM(float32Array: Float32Array): ArrayBuffer {

    const buffer = new ArrayBuffer(float32Array.length * 2);

    const view = new DataView(buffer);

    let offset = 0;

    for (let i = 0; i < float32Array.length; i++, offset += 2) {

      let s = Math.max(-1, Math.min(1, float32Array[i]));

      view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);

    }

    return buffer;

  }


}
